import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { appConfig } from '@/config/app'
import { BrowserAuthRedirect } from '@/components/auth/BrowserAuthRedirect'
import { useAppStore } from '@/store/appStore'
import { isBrowserAppRuntime } from '@/utils/runtime'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const uiColors = appConfig.ui.colors
  const isAuthenticated = useAppStore((state) => state.isAuthenticated)
  const isLoading = useAppStore((state) => state.isLoading)
  const token = useAppStore((state) => state.token)
  const location = useLocation()

  if (isLoading) {
    return (
      <div className={`min-h-screen ${uiColors.pageBg} flex items-center justify-center`}>
        <div className={`w-10 h-10 border-4 ${uiColors.accentBlueBorder} border-t-transparent rounded-full animate-spin`} />
      </div>
    )
  }

  if (!isAuthenticated || !token) {
    if (isBrowserAppRuntime()) {
      return (
        <BrowserAuthRedirect
          pathname={location.pathname}
          search={location.search}
          hash={location.hash}
        />
      )
    }

    return <Navigate to="/" state={{ from: location }} replace />
  }

  return <>{children}</>
}
